<template>
  <!-- 模板方案 -->
  <div class="banner-config-wrapper user-set-wrapper">
    <div class="headerCom">
      <publicBreadCrumb :breadList="breadList" />
      <publicExpandSearch :searchList="searchListGroup" ref="expSearch" :rightEventList="rightEventListGroup"
        :padBottom="'0'" @rightFunc="rightFuncGroup" v-on:getSearchObj="getSearchObjGroup"
        v-if="this.activeName == 'first'">
      </publicExpandSearch>
      <publicExpandSearch :searchList="searchList" ref="expSearch" :rightEventList="rightEventList" :padBottom="'0'"
        @rightFunc="rightFunc" v-on:getSearchObj="getSearchObj" v-if="this.activeName == 'second'"></publicExpandSearch>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="标签患者集合" name="first"> </el-tab-pane>
        <el-tab-pane label="上传用户集合" name="second"> </el-tab-pane>
      </el-tabs>
    </div>
    <el-main>
      <div class="text">
        <div v-if="activeName == 'first'" class="list-two">
          <BaseTable :data="groupdataList" :optimize="true" tooltip-effect="dark" :column="tableConfig"
            :auto-scroll="true" pagination :total="totalGroup" :page.sync="searchParamsGroup.current"
            :limit.sync="searchParamsGroup.size" @pagination="groupListRequest"> </BaseTable>
        </div>
        <div v-if="activeName == 'second'" class="list-two">
          <BaseTable :data="tableData" :optimize="true" tooltip-effect="dark" :column="tableConfigUpload"
            :auto-scroll="true" pagination :total="total" :page.sync="searchParams.current"
            :limit.sync="searchParams.size" @pagination="pageListrequest"> </BaseTable>
        </div>
      </div>
    </el-main>
    <!-- 新增集合弹窗 -->
    <!-- <el-dialog :visible.sync="showAddQuestionShop" :close-on-click-modal="false" width="650px" -->
    <el-dialog :visible.sync="showAddQuestionShop" :close-on-click-modal="false" width="650px"
      :before-close="handleCloseShop" title="添加用户集合">
      <div class="dialog-main-content">
        <el-form :model="formStepFirst" label-width="150px" size="mini" :rules="rulesFormFirst" ref="formStepFirst"
          label-position="right" class="edit">
          <!-- <el-form-item label="集合分类:" prop="type">
            <div class="label-item">
              <el-radio-group v-model="formStepFirst.type" @change="scopeTimeChangeType">
                <el-radio label="doctor">医生集合</el-radio> 
                <el-radio label="patient">患者集合</el-radio>
              </el-radio-group>
            </div>
          </el-form-item> -->
          <el-form-item label="集合分类：" prop="type">
            <div class="count-score">
              <div @click="clickIsCountScore('是')">
                <span v-if="formStepFirst.type && formStepFirst.type == 'doctor'" class="select-radio"></span>
                <span v-else class="no-select-radio"></span>
                <span :class="formStepFirst.type && formStepFirst.type == 'doctor' ? 'radio-text':'no-radio-text'">医生集合</span>
              </div>
              <div @click="clickIsCountScore('否')">
                <span v-if="formStepFirst.type && formStepFirst.type == 'patient'" class="select-radio"></span>
                <span v-else class="no-select-radio"></span>
                <span :class="formStepFirst.type && formStepFirst.type == 'patient' ? 'radio-text':'no-radio-text'">患者集合</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="集合名称：" prop="name">
            <div class="label-item">
              <el-input placeholder="请输入集合名称" v-model.trim="formStepFirst.name" maxlength="20" show-word-limit>
              </el-input>
            </div>
          </el-form-item>
          <el-form-item label="集合说明：" prop="describe">
            <div class="label-item">
              <el-input type="textarea" placeholder="请输入集合说明" resize="none" v-model.trim="formStepFirst.describe"
                maxlength="50" show-word-limit> </el-input>
            </div>
          </el-form-item>
          <el-form-item label="启用状态：" prop="recordStatus">
            <div class="label-item">
              <el-radio-group v-model="formStepFirst.recordStatus" @change="scopeTimeChange">
                <el-radio :label="1">启用</el-radio>
                <el-radio :label="0">停用</el-radio>
              </el-radio-group>
            </div>
          </el-form-item>
          <el-form-item label="用户集合：" prop="file" style="margin-bottom:10px"
            v-if="formStepFirst.type == 'doctor' || formStepFirst.type == 'patient'">
            <div v-if="!excelName" class="label-item">
              <el-upload class="upload-demo" drag action="##" :http-request="uploadServerLog" :show-file-list="false">
                <div class="el-upload__text" v-if="excelName">{{excelName}}</div>
                <div class="el-upload__text" v-else>+ 上传Excel</div>
              </el-upload>
            </div>
            <div v-if="excelName" class="uploaded-pdf">
              <img src="@/assets/images/excel-icon.png" style="margin-right:18px" />
              <span style="vertical-align:top" class="pdf-name" :title="excelName">{{excelName}}</span>

              <!-- <el-button type="text" style="margin-left:20px" size="small" @click="delPdfName">删除</el-button> -->
              <el-upload action="##" :http-request="uploadServerLog" :show-file-list="false">
                <el-button type="text" style="margin-left:20px" size="small">重新上传</el-button>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label=" " class="mb" v-if="formStepFirst.type == 'doctor' || formStepFirst.type == 'patient'">
            <a class="addIndexValue" href="https://jiayi-dsicm-share.oss-cn-hangzhou.aliyuncs.com/集合模板.xlsx"
              download="集合模板.xlsx" @click="addIndexValueQuantitativemClick"><img
                src="../../../assets/images/template-icon.png" alt="" />下载模板</a>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="handleCloseShop" size="small">取消</el-button>
          <el-button type="primary" v-preventReClick size="small" @click="confirmSubmit('formStepFirst')">提交</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="集合详情" :visible.sync="showContentDialog" width="fit-content" :modal-append-to-body="true"
      :append-to-body="true" :before-close="handleClose">
      <div class="relate-push-warapper">
        <div class="relate-box">
          <!-- 新增运营消息 -->
          <div class="relate-box-left">
            <h1 class="top_title"><span></span>运营消息</h1>
            <el-form :model="formStepFirstEdit" label-width="150px" size="mini" :rules="rulesFormFirstEdit"
              ref="formStepFirstEdit" label-position="right" class="edit">
              <el-form-item label="集合分类:" prop="time">
                <div class="label-item">
                  <span v-if="formStepFirstEdit.type == 'doctor'">医生集合</span>
                  <span v-else>患者集合</span>
                </div>
              </el-form-item>
              <el-form-item label="集合名称：" prop="name">
                <div class="label-item">
                  <el-input placeholder="请输入集合名称" v-model.trim="formStepFirstEdit.name" :disabled="seeFlag"
                    maxlength="20" show-word-limit> </el-input>
                </div>
              </el-form-item>
              <el-form-item label="集合说明：" prop="describe">
                <div class="label-item">
                  <el-input type="textarea" placeholder="请输入集合说明" resize="none" :disabled="seeFlag"
                    v-model.trim="formStepFirstEdit.describe" maxlength="50" show-word-limit> </el-input>
                </div>
              </el-form-item>
              <el-form-item label="启用状态：" prop="recordStatus">
                <div class="label-item">
                  <el-radio-group v-model="formStepFirstEdit.recordStatus" :disabled="seeFlag"
                    @change="scopeTimeChange">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="0">停用</el-radio>
                  </el-radio-group>
                </div>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer-detail" v-if="seeFlag">
              <el-button type="primary" size="small" @click="editSubmit">编辑</el-button>
            </div>
            <div slot="footer" class="dialog-footer-detail" v-else>
              <el-button @click="cancelSubmit" size="small">重置</el-button>
              <el-button type="primary" v-preventReClick size="small" @click="confirmSubmitDetail('formStepFirstEdit')">保存</el-button>
            </div>
          </div>
          <!-- 消息模板 -->
          <div class="relate-box-right" v-if="showTemplateDialog">
            <h1 class="top_title"><span></span>用户集合</h1>
            <div class="dialog-right-content">
              <div class="search-box">
                <!-- <div class="search-box-left"> -->
                <el-input placeholder="请输入姓名或手机号" v-model.trim="listQueryTemplate.search" maxlength="20"
                  size="small"></el-input>
                <!-- </div> -->
                <div class="search-box-right">
                  <el-button @click="resetClickTemplate" size="small">重置</el-button>
                  <el-button type="primary" @click="searchClickTemplate" size="small">搜索</el-button>
                </div>
              </div>
              <div>
                <div class="main-content-list" style="max-height: 430px; overflow: auto">
                  <el-table :data="tableDataTemplate" style="width: 100%" :header-cell-style="{
                      background: '#FAFAFA',
                      fontWeight: 'bold',
                      color: '#333333',
                      fontSize: '14px',
                    }">
                    <el-table-column prop="userId" label="用户ID" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="name" label="姓名" align="center" show-overflow-tooltip> </el-table-column>
                    <el-table-column prop="phone" label="手机号" align="center"></el-table-column>
                    <el-table-column label="操作" align="center">
                      <template slot-scope="scope">
                        <el-button @click.native.prevent="toUserDetail(scope.$index, scope.row)" type="text"
                          size="small"> 详情 </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 分页 -->
                <div class="cardpage" style="text-align: right; margin-right: 30px; margin-top: 30px">
                  <el-pagination background :current-page="listQueryTemplate.current" :page-sizes="[10, 20, 30, 50]"
                    :page-size="listQueryTemplate.size" layout="total, sizes, prev, pager, next, jumper"
                    :total="totalTemplate" @size-change="handleSizeChangeTemplate"
                    @current-change="handleCurrentChangeTemplate" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
import axios from "axios";
import {
  saveUserList,
  userListDetail,
  pageUserList,
  pageUserDetailList,
  groupEdit
} from "@/api/userSet.js";

import {
  getStrategicDiseaseAndWechat,
  setTop,
  setStatus,
  deleteBanner,
  wechatApp,
  wechatBanner,
  wechatBannerEdit
} from "../api/medicalInquirie";

import {
  pageList,
  pagelandDelete,
  publish,
  termListData,
  getLandingpageGoodsStatusByLandingPageId
} from "../api/landPage";
import { groupList, groupEnable } from "@/api/Patientmanagement.js";
export default {
  data() {
    return {
      breadList: [{ name: "运营管理" }, { name: "用户集合" }],
      rightEventListGroup: [{ eventName: "新增集合", eventValue: 1 }],
      rightEventList: [{ eventName: "新增集合", eventValue: 1 }],
      searchListGroup: [
        {
          label: "集合名称",
          paramName: "name",
          inputType: "input"
        },
        {
          label: "日期",
          paramName: "updateTime",
          stringTime: "updateTime",
          inputType: "datetimerange",
          paramstartTime: "beginTime",
          paramEndTime: "endTime",
          isTime: true
        }
      ],
      searchList: [
        {
          label: "集合名称",
          paramName: "name",
          inputType: "input"
        },
        {
          label: "创建日期",
          value: 7,
          paramName: "createDate",
          inputType: "datetimerangesing",
          isTime: false,
          paramstartTime: "createDate"
          // paramEndTime: "endTime"
        }
      ],
      searchParams: {
        current: 1,
        size: 10,
      },
      tableConfig: [
        {
          label: "集合名称",
          align: "center",
          prop: "name"
        },
        {
          label: "集合说明",
          align: "center",
          prop: "describe"
        },
        {
          label: "创建人",
          align: "center",
          prop: "createUserName"
        },

        {
          label: "创建时间",
          align: "center",
          prop: "createTime"
        },
        {
          label: "启用状态",
          align: "center",
          prop: "recordStatus",
          // render: (h, scope) => {
          //   return h("div", [
          //     h("span", scope.row.recordStatus ? "启用" : "停用")
          //   ]);
          // }
          render: (h, scope) => {
            if (!scope.row.recordStatus) {
              return (
                <span
                  slot="reference"
                  style="display:inline-block;background: #FCB023;height:24px;line-height:24px;width:44px;text-align:center;color:#FFFFFF"
                >
                  停用
                </span>
              );
            }
            if (scope.row.recordStatus) {
              return (
                <span
                  slot="reference"
                  style="display:inline-block;background: #0CB79F;height:24px;line-height:24px;width:44px;text-align:center;color:#FFFFFF"
                >
                  启用
                </span>
              );
            }
          }
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.seeUserClick(scope.row);
                    }
                  }
                },
                "查看用户"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      // this.deleteClick(scope.row);
                      this.seeAssembleClick(scope.row);
                    }
                  }
                },
                "查看集合"
              ),
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.publishGroupClick(scope.row, scope.row.recordStatus);
                    }
                  }
                },
                scope.row.recordStatus ? "停用" : "启用"
              )
            ]);
          }
        }
      ],
      tableConfigUpload: [
        {
          label: "集合名称",
          align: "center",
          prop: "name"
        },
        {
          label: "集合说明",
          align: "center",
          prop: "describe"
        },
        {
          label: "集合分类",
          align: "center",
          prop: "type",
          render: (h, scope) => {
            return h("div", [
              h("span", scope.row.type == 'patient' ? "患者集合" : scope.row.type == 'doctor' ? "医生集合":"")
            ]);
          }
        },
        {
          label: "创建人",
          align: "center",
          prop: "createUserName"
        },

        {
          label: "创建时间",
          align: "center",
          prop: "createTime"
        },
        {
          label: "启用状态",
          align: "center",
          prop: "recordStatus",
          // 状态1：启用,0:禁用(默认1)
          render: (h, scope) => {
            if (!scope.row.recordStatus) {
              return (
                <span
                  slot="reference"
                  style="display:inline-block;background: #FCB023;height:24px;line-height:24px;width:44px;text-align:center;color:#FFFFFF"
                >
                  禁用
                </span>
              );
            }
            if (scope.row.recordStatus) {
              return (
                <span
                  slot="reference"
                  style="display:inline-block;background: #0CB79F;height:24px;line-height:24px;width:44px;text-align:center;color:#FFFFFF"
                >
                  启用
                </span>
              );
            }
          }
        },
        {
          label: "操作",
          align: "center",
          width: "200px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.seeClick(scope.row);
                    }
                  }
                },
                "查看"
              )
            ]);
          }
        }
      ],
      loading: false,
      checkStatusList: ["新建", "待审核", "已通过", "被驳回"],
      showTagObj: {
        searchContent: "",
        diseaseTypeName: "",
        subDiseaseTypeName: "",
        experiencePack: "",
        available: "",
        status: ""
      },
      total: 0,
      diseaseListData: [],
      platFormType: 1,
      userPlatForm: "platForm",

      showDialog: false,
      loading: false,
      total: 0, //总条数
      tableData: [],
      options: [],
      imgPath: process.env.VUE_APP_OSS_URL,
      edit: true,
      flag: false,
      VUE_APP_WECHATBASE_URL: "/api/dsicm-contact-platform/feign/file/upload",
      getMethodsList: [],
      bannerList: [{ name: "首页banner", value: "banner" }],
      // diseaseList: [],
      checkDisease: [],
      imgPath: process.env.VUE_APP_OSS_URL,
      timeList: [],
      resetFlag: true,
      editFlag: false, //是否编辑
      id: null,
      options: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7; //如果没有后面的-8.64e7就是不可以选择今天的
        }
      },
      arr: [],
      getEndTime: 0,
      showAddQuestionShop: false, //添加用户集合弹窗
      listQueryShop: {
        //商品搜索条件
        //弹窗
        current: 1,
        size: 10,
        goodsName: null
      },
      tableDataShop: [], //添加集合数组
      showContentDialog: false,
      formStepFirst: {
        //表单value值
        recordStatus: 1,
        file: null,
        id: null,
        name: null,
        describe: null,
        type: null
      },
      formStepFirstEdit: {
        //表单value值
        recordStatus: 1,
        file: null,
        id: null,
        name: null,
        describe: null,
        type: null
      },
      rulesFormFirst: {
        //验证表单
        type: [
          { required: true, message: "请选择集合分类", trigger: "change" }
        ],
        name: [{ required: true, message: "请填写集合名称", trigger: "blur" }],
        describe: [
          { required: true, message: "请选择集合说明", trigger: "blur" }
        ],
        recordStatus: [
          { required: true, message: "请选择启用状态", trigger: "change" }
        ],
        file: [{ required: true, message: "请上传用户集合", trigger: "change" }]
      },
      rulesFormFirstEdit: {
        //验证表单
        type: [
          { required: true, message: "请选择集合分类", trigger: "change" }
        ],
        name: [{ required: true, message: "请填写集合名称", trigger: "blur" }],
        describe: [
          { required: true, message: "请选择集合说明", trigger: "blur" }
        ],
        recordStatus: [
          { required: true, message: "请选择启用状态", trigger: "change" }
        ],
        file: [{ required: true, message: "请上传用户集合", trigger: "change" }]
      },
      selectList: [], //选中的模板
      totalShop: 0,
      serviceUrl: null,
      serviceName: null,
      selectList: [
        {
          title: "sss"
        }
      ],
      activeName: "first",
      listQueryTemplate: {
        //商品搜索条件
        //弹窗
        current: 1,
        size: 10,
        search: null,
        groupId: null
      },
      // tableDataTemplate: [], //添加集合数组
      tableDataTemplate: [
        {
          userId: 1
        }
      ], //添加集合数组
      sendList: [], //数组
      showTemplateDialog: true, //模板是否展示
      seeFlag: true, //状态
      groupdataList: [], //标签患者集合
      searchParamsGroup: {
        current: 1,
        size: 10
      },
      totalGroup: 0,
      excelName: null,
      totalTemplate: 0,
      hospitalId: null
    };
  },
  created() {
    this.groupListRequest();
    this.pageListrequest();

  },
  filters: {
    //文字长度过滤
    ellipsis(value) {
      if (!value) {
        return;
      }
      if (value.length > 8) {
        return value.slice(0, 8) + "...";
      } else {
        return value;
      }
    }
  },
  methods: {
    clickIsCountScore(key) {
      // let issocre = this.typeFormData.countScore;
      console.log(key, "key");
      if (this.formStepFirst.file) {
        this.$confirm(
          "切换集合后，会清除已上传的用户集合",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }
        )
          .then(async () => {
            if (key == "是") {
              this.formStepFirst.type = "doctor";
            } else {
              this.formStepFirst.type = "patient";
            }
            this.$refs["formStepFirst"].clearValidate("type");
            this.formStepFirst.file = null;
            this.excelName = null
          })
          .catch(() => {});
      } else {
        if (key == "是") {
          this.formStepFirst.type = "doctor";
        } else {
          this.formStepFirst.type = "patient";
        }
        this.$refs["formStepFirst"].clearValidate("type");
      }
    },
    async saveUserListBtn(id) {
      // 根据后台需求数据格式
      const form = new FormData();

      // 文件对象
      form.append("file", this.formStepFirst.file);

      // form.append("id", this.formStepFirst.id ? this.formStepFirst.id : null);
      form.append("name", this.formStepFirst.name);
      form.append("describe", this.formStepFirst.describe);
      form.append("type", this.formStepFirst.type);
      form.append("recordStatus", this.formStepFirst.recordStatus);

      axios
        // .post("/biz/user-list-group", this.formStepFirst)
        .post("/biz/user-list-group", form)
        .then(res => {
          console.log(res, "ress");
          if (res.data.code == 0) {
            this.showAddQuestionShop = false;
            this.pageListrequest();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          // this.gressShow = false;
          // clearInterval(time);
          console.log(err, "err");
        });
    },

    async saveUserListBtnEdit(id) {
      // 根据后台需求数据格式
      const form = new FormData();

      // 文件对象
      form.append("file", this.formStepFirstEdit.file);

      // form.append("id", this.formStepFirst.id ? this.formStepFirst.id : null);
      form.append("name", this.formStepFirstEdit.name);
      form.append("describe", this.formStepFirstEdit.describe);
      form.append("type", this.formStepFirstEdit.type);
      form.append("recordStatus", this.formStepFirstEdit.recordStatus);
      delete this.formStepFirstEdit.file;

      groupEdit(this.formStepFirstEdit).then(res => {
        if (res.code == 0) {
          this.showContentDialog = false;
          this.pageListrequest();
        }
      });

      // axios
      //   // .post("/biz/user-list-group", this.formStepFirst)
      //   .put("/biz/user-list-group", this.formStepFirstEdit)
      //   .then(res => {
      //     console.log(res, "ress");
      //     if (res.data.code == 0) {
      //       this.showContentDialog = false;
      //       this.pageListrequest();
      //     }
      //   })
      //   .catch(err => {
      //   });
    },

    toUserDetail(index, row) {
      console.log(row, "row");
      console.log(this.formStepFirst, "this.formStepFirst.type");
      if (this.formStepFirstEdit.type == "doctor") {
        this.$router.push({
          path: "/Organization/updateMedicalinfo",
          query: { id: row.doctorId }
        });
      }

      // 进入病人管理详情页面
      if (this.formStepFirstEdit.type == "patient") {
        this.$router.push({
          path: "/patientmanage/detail",
          query: {
            patientId: row.patientId,
            userId: row.userId,
            tabIndex: 1
          }
        });
      }
    },
    async getUserGroupDetail(id) {
      let res = await userListDetail(id);
      if (res.code == 0) {
        if (res.data) {
          this.$set(this.formStepFirstEdit, "id", res.data.id);
          console.log(res.data, "asdads");
          this.$set(this.formStepFirstEdit, "name", res.data.name);
          this.$set(this.formStepFirstEdit, "describe", res.data.describe);
          this.$set(this.formStepFirstEdit, "type", res.data.type);
          this.$set(
            this.formStepFirstEdit,
            "recordStatus",
            res.data.recordStatus == true ? 1 : 0
          );
          this.$set(this.formStepFirstEdit, "file", res.data.file);
          this.hospitalId = res.data.hospitalId;
        } else {
          this.$set(this.formStepFirstEdit, "id", null);
          this.$set(this.formStepFirstEdit, "name", null);
          this.$set(this.formStepFirstEdit, "describe", null);
          this.$set(this.formStepFirstEdit, "type", null);
          this.$set(this.formStepFirstEdit, "recordStatus", null);
          this.$set(this.formStepFirstEdit, "file", null);
        }
      } else {
      }
    },
    getSearchObjGroup(obj) {
      this.searchParamsGroup = this.$options.data().searchParams;
      this.searchParamsGroup = { ...obj, ...this.searchParamsGroup };
      this.groupListRequest();
    },
    getSearchObj(obj) {
      this.searchParams = this.$options.data().searchParams;
      this.searchParams = { ...obj, ...this.searchParams };
      this.pageListrequest();
    },
    rightFuncGroup(item) {
      this.$router.push({
        path: "/groupDetails",
        query: { id: null }
      });
    },
    rightFunc(item) {
      //新增集合
      this.showAddQuestionShop = true;
      setTimeout(() => {
        this.$refs["formStepFirst"].clearValidate("type");
        this.$refs["formStepFirst"].clearValidate("recordStatus");
      }, 1000);
      this.excelName = null;
      this.$set(this.formStepFirst, "id", null);
      this.$set(this.formStepFirst, "name", null);
      this.$set(this.formStepFirst, "describe", null);
      this.$set(this.formStepFirst, "type", null);
      this.$set(this.formStepFirst, "recordStatus", 1);
      this.$set(this.formStepFirst, "file", null);
    },
    pageListrequest() {
      pageUserList(this.searchParams).then(res => {
        if (res.code == 0) {
          if (res.data) {
            if (res.data.records && res.data.records.length > 0) {
              this.tableData = res.data.records;
              this.total = res.data.total;
            } else {
              this.tableData = [];
              this.total = 0;
            }
          } else {
            this.tableData = [];
            this.total = 0;
          }
        }
      });

      // let res = await pageUserList({
      //   name: "",
      //   createDate: ""
      // });
      // if (res.code == 0) {
      // }
    },
    seeUserClick(item) {
      this.$router.push({
        path: "/groupList",
        query: {
          id: item.id
        }
      });
    },
    seeClick(item) {
      this.seeFlag = true;
      this.showContentDialog = true;
      this.$set(this.formStepFirstEdit, "id", null);
      this.$set(this.formStepFirstEdit, "name", null);
      this.$set(this.formStepFirstEdit, "describe", null);
      this.$set(this.formStepFirstEdit, "type", null);
      this.$set(this.formStepFirstEdit, "recordStatus", null);
      this.$set(this.formStepFirstEdit, "file", null);

      this.listQueryTemplate.groupId = item.id;

      this.getUserGroupDetail(item.id);

      this.shopPageRequest();
      setTimeout(() => {
        this.$refs["formStepFirstEdit"].clearValidate("type");
        this.$refs["formStepFirstEdit"].clearValidate("name");
        this.$refs["formStepFirstEdit"].clearValidate("describe");
        this.$refs["formStepFirstEdit"].clearValidate("recordStatus");
      }, 100);
    },
    publishClick(item, status) {
      //发布 || 下架
      if (!status) {
        this.$confirm("消息正在发送中，停用可能会中止继续发送~", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        })
          .then(() => {})
          .catch(() => {});
      } else {
        this.$confirm("消息正在发送中，停用可能会中止继续发送~", "确认信息", {
          distinguishCancelAndClose: true,
          confirmButtonText: "继续",
          cancelButtonText: "取消",
          customClass: "message-confirm-style"
        })
          .then(() => {
            // publish({
            //   landingPageId: item.id,
            //   isPublish: !status
            // }).then(res => {
            //   if (res.code == 0) {
            //     if (status) {
            //       this.$message.success("下架成功");
            //     } else {
            //       this.$message.success("发布成功");
            //     }
            //     this.pageListrequest();
            //   }
            // });
          })
          .catch(() => {});
      }
    },
    publishGroupClick(item, status) {
      let param = {
        enable: item.recordStatus == 1 ? false : true,
        id: item.id
      };
      let title = "";
      if (item.recordStatus) {
        title = "停用";
      } else {
        title = "启用";
      }
      this.$confirm(`确定要${title}该分组吗？`, "提示", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      })
        .then(() => {
          groupEnable(param).then(res => {
            if (res.code == 0) {
              this.$message({
                message: "更新成功！",
                type: "success",
                duration: 1000
              });
              this.groupListRequest();
            }
          });
        })
        .catch(() => {});
    },
    //删除事件
    deleteClick(item, index) {
      this.$confirm("确定要删除吗？", "确认信息", {
        distinguishCancelAndClose: true,
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        customClass: "message-confirm-style"
      })
        .then(() => {
          pagelandDelete({
            id: item.id
          }).then(res => {
            if (res.code == 0) {
              this.$message.success("删除成功");
              this.pageListrequest();
            }
          });
          if (this.total <= this.searchParams.size) {
            this.searchParams.current = 1;
          }
        })
        .catch(() => {});
    },
    shopPageRequest() {
      pageUserDetailList(this.listQueryTemplate)
        .then(res => {
          if (res.code == 0) {
            if (res.data) {
              if (res.data.records) {
                this.tableDataTemplate = res.data.records;
              } else {
                this.tableDataTemplate = [];
              }
              this.totalTemplate = res.data.total;
            } else {
              this.totalTemplate = 0;
              this.tableDataTemplate = [];
            }
          } else {
            this.totalTemplate = 0;
            this.tableDataTemplate = [];
          }
        })
        .catch(res => {
          this.totalTemplate = 0;
          this.tableDataTemplate = [];
        });
    },
    handleCloseShop() {
      //添加集合弹窗关闭
      this.$refs["formStepFirst"].clearValidate("type");
      this.$refs["formStepFirst"].clearValidate("name");
      this.$refs["formStepFirst"].clearValidate("describe");
      this.$refs["formStepFirst"].clearValidate("recordStatus");
      this.$refs["formStepFirst"].clearValidate("file");
      this.showAddQuestionShop = false;
    },
    handleClose() {
      //运营消息弹窗关闭
      this.showContentDialog = false;
    },
    assessmentSendShop(index, row) {
      this.tableDataShop[index].flag = false;
      //选择集合
      this.tableDataShop[index].flag = false;
      this.shopNameList.push(objService);
      this.phoneList[this.index].goods = this.shopNameList;
      this.showContentDialog = true;
      this.showAddQuestionShop = false;
      this.showContentDialog = true;
    },
    handleSizeChangeTemplate(val) {
      //添加集合分页
      this.listQueryTemplate.size = val;
      this.listQueryTemplate.current = 1;
      this.shopPageRequest();
    },
    handleCurrentChangeTemplate(val) {
      //添加集合分页
      this.listQueryTemplate.current = val;
      this.shopPageRequest();
    },
    delLabel(index) {
      //删除的选中的模板
      this.selectList.splice(index, 1);
    },
    cancelSubmit() {
      this.$set(this.formStepFirstEdit, "name", null);
      this.$set(this.formStepFirstEdit, "describe", null);
      // this.$set(this.formStepFirstEdit, "type", null);
      this.$set(this.formStepFirstEdit, "recordStatus", null);
      this.$set(this.formStepFirstEdit, "file", null);
      setTimeout(() => {
        this.$refs["formStepFirstEdit"].clearValidate("recordStatus");
      }, 100);
    },
    editSubmit() {
      this.seeFlag = false;
    },
    confirmSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveUserListBtn();
        } else {
          return false;
        }
      });
    },
    confirmSubmitDetail(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveUserListBtnEdit();
        } else {
          return false;
        }
      });
      // this.saveUserListBtn()
    },
    scopeApplicationChange(value) {},
    scopeTimeChange(value) {},
    addIndexValueQuantitativemClick() {
      this.showContentDialog = false;
      this.showAddQuestionShop = true;
    },
    resetClickTemplate() {
      //弹窗集合服务重置
      this.listQueryTemplate.size = 10;
      this.listQueryTemplate.current = 1;
      this.listQueryTemplate.search = null;
      this.shopPageRequest();
    },
    searchClickTemplate() {
      //弹窗集合服务搜索
      this.listQueryTemplate.size = 10;
      this.listQueryTemplate.current = 1;
      this.shopPageRequest();
    },
    sendChange() {},
    seeAssembleClick(item) {
      //查看
      this.$router.push({
        path: "/groupDetails",
        query: {
          id: item.id
        }
      });
    },
    handleClick(event) {
      if (this.activeName == "first") {
        this.groupListRequest();
      } else if (this.activeName == "second") {
        this.pageListrequest();
      }
    },
    async uploadServerLog(params) {
      console.log(params.file);
      const file = params.file;
      const rule = /\.(xls|xlsx)$/;
      if (file.name.match(rule) == null) {
        this.$message.error("只能上传excel格式!");
        return false;
      }
      this.gressShow = true;
      console.log(file.name, "file");
      console.log(file.size, "file");
      if (file.size > 0) {
        this.excelName = file.name;
        this.$refs["formStepFirst"].clearValidate("file");
        this.$message.success("上传成功");
      } else {
        this.excelName = null;
        // this.$message.success('上传成功');
      }
      this.formStepFirst.file = file;
    },
    groupListRequest() {
      groupList(this.searchParamsGroup).then(res => {
        if (res.code == 0) {
          this.totalGroup = res.data.total;
          if (res.data && res.data.records) {
            this.groupdataList = res.data && res.data.records;
          } else {
            this.groupdataList = [];
          }
        } else {
          this.totalGroup = 0;
          this.groupdataList = [];
        }
      });
    },
    scopeTimeChangeType(val) {
      // this.$confirm("切换集合后，会清除已上传的用户集合", "确认信息", {
      //   distinguishCancelAndClose: true,
      //   confirmButtonText: "确认",
      //   cancelButtonText: "取消",
      //   customClass: "message-confirm-style"
      // }).then(() => {
      //   this.formStepFirst.type = val;
      // }).catch(() => {
      // });
    }
  }
};
</script>
  
<style lang="less" scoped>
@import "./userSet.less";
.uploaded-pdf {
  width: 100%;
  height: 68px;
  background: #f7fafb;
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  img {
    width: 36px;
    height: 44px;
  }
  .pdf-name {
    display: inline-block;
    width: 306px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
/deep/.el-form-item__label{
  padding-right:20px !important;
}
</style>
<style lang="less">
.popconfirmbox .el-popconfirm__main {
  align-items: flex-start !important;
  line-break: anywhere !important;
  margin: 0 0 10px 0 !important;
  letter-spacing: -1px;
}
.popconfirmbox .el-popconfirm__main .el-popconfirm__icon {
  margin-top: 3px;
}
.user-set-wrapper {
  .el-tabs__header {
    margin-bottom: 0;
  }
  .el-tabs__item {
    font-size: 14px;
    // color: #333333;
  }
  .el-tabs__nav-wrap::after {
    height: 0px !important;
  }
}

.count-score {
  display: flex;

  div {
    width: 84px;
    margin-right: 30px;
    display: flex;
    align-items: center;
    cursor: pointer;
    .no-select-radio {
      border: 1px solid #dcdfe6;
      border-radius: 100%;
      width: 14px;
      height: 14px;
      background-color: #fff;
      position: relative;
      cursor: pointer;
      display: inline-block;
      box-sizing: border-box;
    }

    .select-radio {
      width: 14px;
      height: 14px;
      background-color: #fff;
      border-radius: 50%;
      border: 5px solid #1a7bfc;
      display: inline-block;
    }

    .radio-score-text {
      display: inline-block;
      margin-left: 8px;
    }

    .radio-text {
      display: inline-block;
      margin-left: 10px;
      font-size: 14px;
      color: #1a7bfc;
      font-weight: 500;
    }

    .no-radio-text {
      display: inline-block;
      margin-left: 10px;
      font-size: 14px;
      color: #606266;
      font-weight: 500;
    }
  }
}

</style>
  